import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6478c4f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger mt-3",
  role: "alert"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 車台番号を正しく入力してください")
const _hoisted_4 = {
  key: 1,
  class: "alert alert-danger mt-3",
  role: "alert"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" １７桁の車台番号を正しく入力してください")
const _hoisted_6 = { class: "container rounded-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mt-3 mb-1" }, [
  /*#__PURE__*/_createTextVNode(" 自動車検査証に記載の車台番号を"),
  /*#__PURE__*/_createElementVNode("label", { class: "text-danger" }, "半角英数字"),
  /*#__PURE__*/_createTextVNode("で入力し、「検索」ボタンを押してください。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 車台番号は例に従ってそれぞれの入力欄に入力してください。 ")
], -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "horizon" }, null, -1 /* HOISTED */))
const _hoisted_9 = { class: "row ms-3" }
const _hoisted_10 = { class: "form-check text-left" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label",
  for: "search_dom"
}, "車台番号がハイフンで分かれている場合", -1 /* HOISTED */))
const _hoisted_12 = {
  key: 0,
  class: "row ms-3 g-1"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-auto col-form-label" }, "車台番号:", -1 /* HOISTED */))
const _hoisted_14 = { class: "col-auto" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-auto col-form-label" }, "-", -1 /* HOISTED */))
const _hoisted_16 = { class: "col-auto" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-start" }, " 入力例: HA36S - 123456", -1 /* HOISTED */))
const _hoisted_18 = {
  key: 1,
  class: "row ms-3 g-1"
}
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<label class=\"col-auto col-form-label\" data-v-6478c4f7>車台番号:</label><div class=\"col-auto\" data-v-6478c4f7><input type=\"text\" class=\"form-control\" disabled data-v-6478c4f7></div><label class=\"col-auto col-form-label\" data-v-6478c4f7>-</label><div class=\"col-auto\" data-v-6478c4f7><input type=\"text\" class=\"form-control\" disabled data-v-6478c4f7></div><label class=\"text-start\" data-v-6478c4f7> 入力例: HA36S - 123456</label>", 5)
const _hoisted_24 = [
  _hoisted_19
]
const _hoisted_25 = { class: "row ms-3" }
const _hoisted_26 = { class: "form-check text-left" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "col-form-label",
  for: "search_imp"
}, "車台番号が１７桁の場合", -1 /* HOISTED */))
const _hoisted_28 = {
  key: 2,
  class: "row ms-3 g-1"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-auto col-form-label" }, "車台番号:", -1 /* HOISTED */))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-7" }, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    class: "form-control col-auto",
    disabled: ""
  })
], -1 /* HOISTED */))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-start mb-3" }, " 入力例: TSMEXB32S00123456", -1 /* HOISTED */))
const _hoisted_32 = [
  _hoisted_29,
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = {
  key: 3,
  class: "row ms-3 g-1"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-auto col-form-label" }, "車台番号:", -1 /* HOISTED */))
const _hoisted_35 = { class: "col-sm-7" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-start mb-3" }, " 入力例: TSMEXB32S00123456", -1 /* HOISTED */))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search" }, null, -1 /* HOISTED */))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "検索", -1 /* HOISTED */))
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-3" }, [
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createTextVNode(" ■自動車検査証（車検証）車台番号記載位置サンプル "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ※ 軽自動車は、旧様式と新様式がありますのでご注意ください。")
  ])
], -1 /* HOISTED */))
const _hoisted_41 = { class: "table-position mt-3" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, [
    /*#__PURE__*/_createElementVNode("label", null, "軽自動車（平成16年10月14日～）")
  ]),
  /*#__PURE__*/_createElementVNode("td", null, [
    /*#__PURE__*/_createElementVNode("label", null, "軽自動車（～平成16年10月13日）")
  ])
], -1 /* HOISTED */))
const _hoisted_43 = {
  "data-bs-toggle": "modal",
  "data-bs-target": "#kei_new"
}
const _hoisted_44 = ["src"]
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "※画像をクリックすると拡大します", -1 /* HOISTED */))
const _hoisted_46 = {
  "data-bs-toggle": "modal",
  "data-bs-target": "#kei_old"
}
const _hoisted_47 = ["src"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "※画像をクリックすると拡大します", -1 /* HOISTED */))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "mt-3" }, [
  /*#__PURE__*/_createElementVNode("td", null, [
    /*#__PURE__*/_createElementVNode("label", { class: "mt-3 text-left" }, "普通自動車")
  ]),
  /*#__PURE__*/_createElementVNode("td")
], -1 /* HOISTED */))
const _hoisted_50 = {
  "data-bs-toggle": "modal",
  "data-bs-target": "#kogata"
}
const _hoisted_51 = ["src"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted" }, "※画像をクリックすると拡大します", -1 /* HOISTED */))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1 /* HOISTED */))
const _hoisted_54 = {
  class: "modal fade",
  id: "kei_new",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_55 = { class: "modal-dialog modal-dialog-centered modal-width" }
const _hoisted_56 = { class: "modal-content" }
const _hoisted_57 = { class: "modal-body" }
const _hoisted_58 = ["src"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, " 閉じる ")
], -1 /* HOISTED */))
const _hoisted_60 = {
  class: "modal fade",
  id: "kei_old",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_61 = { class: "modal-dialog modal-dialog-centered modal-width" }
const _hoisted_62 = { class: "modal-content" }
const _hoisted_63 = { class: "modal-body" }
const _hoisted_64 = ["src"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, " 閉じる ")
], -1 /* HOISTED */))
const _hoisted_66 = {
  class: "modal fade",
  id: "kogata",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_67 = { class: "modal-dialog modal-dialog-centered modal-width" }
const _hoisted_68 = { class: "modal-content" }
const _hoisted_69 = { class: "modal-body" }
const _hoisted_70 = ["src"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
  }, " 閉じる ")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createVNode($setup["Header"]),
    ($setup.isDomError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.clearErrors()))
          })
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.isImpError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.clearErrors()))
          })
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("form", null, [
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              id: "search_dom",
              value: "search_dom",
              name: "radio",
              type: "radio",
              class: "form-check-input",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.radio) = $event)),
              onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.clearVinNo())),
              checked: ""
            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelRadio, $setup.radio]
            ]),
            _hoisted_11
          ])
        ]),
        ($setup.radio === 'search_dom')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.vinNo1) = $event)),
                  onChange: _cache[5] || (_cache[5] = ($event: any) => ($setup.vinNo1ToUppercase($setup.vinNo1)))
                }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                  [
                    _vModelText,
                    $setup.vinNo1,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.vinNo2) = $event)),
                  onChange: _cache[7] || (_cache[7] = ($event: any) => ($setup.vinNo2ToUppercase($setup.vinNo2)))
                }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                  [
                    _vModelText,
                    $setup.vinNo2,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _hoisted_17
            ]))
          : ($setup.radio === 'search_imp')
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_24))
            : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _withDirectives(_createElementVNode("input", {
              id: "search_imp",
              value: "search_imp",
              name: "radio",
              type: "radio",
              class: "form-check-input",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.radio) = $event)),
              onChange: _cache[9] || (_cache[9] = ($event: any) => ($setup.clearVinNo()))
            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
              [_vModelRadio, $setup.radio]
            ]),
            _hoisted_27
          ])
        ]),
        ($setup.radio === 'search_dom')
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_32))
          : ($setup.radio === 'search_imp')
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control col-auto",
                    maxlength: "17",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.vinNo3) = $event)),
                    onChange: _cache[11] || (_cache[11] = ($event: any) => ($setup.vinNo3ToUppercase($setup.vinNo3)))
                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                    [
                      _vModelText,
                      $setup.vinNo3,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _hoisted_36
              ]))
            : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-primary mt-3",
      onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.submit()))
    }, _hoisted_39),
    _hoisted_40,
    _createElementVNode("table", _hoisted_41, [
      _createElementVNode("tbody", null, [
        _hoisted_42,
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("img", {
                src: require('@/assets/img/kei_new_sam.gif')
              }, null, 8 /* PROPS */, _hoisted_44)
            ]),
            _hoisted_45
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("img", {
                src: require('@/assets/img/kei_old_sam.gif')
              }, null, 8 /* PROPS */, _hoisted_47)
            ]),
            _hoisted_48
          ])
        ]),
        _hoisted_49,
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("img", {
                src: require('@/assets/img/kogata_sam.gif')
              }, null, 8 /* PROPS */, _hoisted_51)
            ]),
            _hoisted_52
          ]),
          _hoisted_53
        ])
      ])
    ]),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_54, [
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("img", {
              src: require('@/assets/img/kei_new.gif')
            }, null, 8 /* PROPS */, _hoisted_58)
          ]),
          _hoisted_59
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("img", {
              src: require('@/assets/img/kei_old.gif')
            }, null, 8 /* PROPS */, _hoisted_64)
          ]),
          _hoisted_65
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_66, [
      _createElementVNode("div", _hoisted_67, [
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("img", {
              src: require('@/assets/img/kogata.gif')
            }, null, 8 /* PROPS */, _hoisted_70)
          ]),
          _hoisted_71
        ])
      ])
    ]),
    _createVNode($setup["Footer"])
  ]))
}